<template>
  <div class="main-page">
    <!--banner-->
    <div class="banner" ref="banner">
      <app-swiper :language="language"></app-swiper>
    </div>

    <!--4个详情下拉菜单-->
    <div class="tab-section">
      <div class="tab-main">
        <ul class="outer">
          <li class="outer-item show-detail">
            <div class="top-travel clear" v-tap="{ methods: showTabDetail }">
              <div class="fl">
                <img
                  class="icon icon1"
                  src="~assets/main-page/home_icon_01@3x.png"
                />
                <span class="text">{{ $t("language.mainWhatWan") }}</span>
              </div>
              <div class="triangle-contain fr">
                <img
                  class="trangle"
                  src="~assets/main-page/home_btn_default@3x.png"
                />
              </div>
            </div>
            <div class="content">
              <a>
                <p>{{ $t("language.mainWhatWanDefined") }}</p>
                <p>{{ $t("language.mainWhatWanGlobal") }}</p>
                <p>{{ $t("language.mainWhatWanConnection") }}</p>
              </a>
            </div>
          </li>
          <li class="outer-item">
            <div class="top-travel clear" v-tap="{ methods: showTabDetail }">
              <div class="fl">
                <img
                  class="icon icon2"
                  src="~assets/main-page/home_icon_02@3x.png"
                />
                <span class="text">{{ $t("language.mainWhyWan") }}</span>
              </div>
              <div class="triangle-contain fr">
                <img
                  class="trangle"
                  src="~assets/main-page/home_btn_default@3x.png"
                />
              </div>
            </div>
            <div class="content">
              <a @click.native="jumpRouter()" push>
                <p>{{ $t("language.mainWhyWanHeight") }}</p>
                <p>{{ $t("language.mainWhyWanStrong") }}</p>
                <p>{{ $t("language.mainWhyWanFlexible") }}</p>
              </a>
            </div>
          </li>
          <li class="p4 outer-item">
            <div class="top-travel clear" v-tap="{ methods: showTabDetail }">
              <div class="fl">
                <img
                  class="icon icon1"
                  src="~assets/main-page/home_icon_03@3x.png"
                />
                <span class="text">{{ $t("language.mainCloud") }}</span>
              </div>
              <div class="triangle-contain fr">
                <img
                  class="trangle"
                  src="~assets/main-page/home_btn_default@3x.png"
                />
              </div>
            </div>
            <div class="content">
              <a>
                <p>{{ $t("language.mainCloudSaas") }}</p>
                <p>{{ $t("language.mainCloudApp") }}</p>
                <p>{{ $t("language.mainCloudSoho") }}</p>
                <p>{{ $t("language.mainCloudRemote") }}</p>
              </a>
            </div>
          </li>
          <li class="p4 outer-item" v-show="language == 'ch'">
            <div class="top-travel clear" v-tap="{ methods: showTabDetail }">
              <div class="fl">
                <img
                  class="icon icon1"
                  src="~assets/main-page/home_icon_04@3x.png"
                />
                <span class="text">{{ $t("language.mainCloud1") }}</span>
              </div>
              <div class="triangle-contain fr">
                <img
                  class="trangle"
                  src="~assets/main-page/home_btn_default@3x.png"
                />
              </div>
            </div>
            <div class="content">
              <a>
                <p>{{ $t("language.mainGlobal") }}</p>
                <p>{{ $t("language.mainData") }}</p>
                <p>{{ $t("language.mainSafeData") }}</p>
                <p>{{ $t("language.mainSimple") }}</p>
              </a>
            </div>
          </li>
          <li class="p4 outer-item" v-show="language == 'en'">
            <div class="top-travel clear" v-tap="{ methods: showTabDetail }">
              <div class="fl">
                <img
                  class="icon icon1"
                  src="~assets/main-page/home_icon_04@3x.png"
                />
                <span class="text">{{
                  $t("language.mainCloudConnection")
                }}</span>
              </div>
              <div class="triangle-contain fr">
                <img
                  class="trangle"
                  src="~assets/main-page/home_btn_default@3x.png"
                />
              </div>
            </div>
            <div class="content">
              <a>
                <p>{{ $t("language.mainCloudBranch") }}</p>
                <p>{{ $t("language.mainCloudData") }}</p>
                <p>{{ $t("language.mainCloudSecured") }}</p>
                <p>{{ $t("language.mainCloudEasy") }}</p> </a
              >>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!--our features渐变块-->
    <div class="feature-section">
      <div class="gradient">
        <div class="top-text-contain">
          <h1 class="top-title">{{ $t("language.mainFeatures") }}</h1>
          <div class="middle-title">{{ $t("language.mainFeaturesWe") }}</div>
          <p class="bottom-text">{{ $t("language.mainFeaturesBuild") }}</p>
        </div>
        <div class="feature-classify">
          <ul class="all-item clear">
            <li class="item fl">
              <div class="img-box">
                <img
                  src="~assets/main-page/home_ourfeatures_icon_01@3x.png"
                  alt=""
                />
              </div>
              <p class="text">{{ $t("language.mainPERFORMANCE") }}</p>
            </li>
            <li class="item fr">
              <div class="img-box">
                <img
                  class="img2"
                  src="~assets/main-page/home_ourfeatures_icon_02@3x.png"
                  alt=""
                />
              </div>
              <p class="text">{{ $t("language.mainSECURITY") }}</p>
            </li>
          </ul>
          <ul class="all-item clear">
            <li class="item fl">
              <div class="img-box">
                <img
                  src="~assets/main-page/home_ourfeatures_icon_03@3x.png"
                  alt=""
                />
              </div>
              <p class="text">{{ $t("language.mainRELIABILITY") }}</p>
            </li>
            <li class="item fr">
              <div class="img-box">
                <img
                  class="img4"
                  src="~assets/main-page/home_ourfeatures_icon_04@3x.png"
                  alt=""
                />
              </div>
              <p class="text">{{ $t("language.mainSMART") }}</p>
            </li>
          </ul>
          <ul class="all-item clear">
            <li class="item fl">
              <div class="img-box">
                <img
                  class="img5"
                  src="~assets/main-page/home_ourfeatures_icon_05@3x.png"
                  alt=""
                />
              </div>
              <p class="text">{{ $t("language.mainEASY") }}</p>
            </li>
            <li class="item fr">
              <div class="img-box">
                <img
                  src="~assets/main-page/home_ourfeatures_icon_06@3x.png"
                  alt=""
                />
              </div>
              <p class="text">{{ $t("language.mainREAL") }}</p>
            </li>
          </ul>
          <ul class="all-item clear">
            <li class="item fl">
              <div class="img-box">
                <img
                  src="~assets/main-page/home_ourfeatures_icon_07@3x.png"
                  alt=""
                />
              </div>
              <p class="text">{{ $t("language.mainANALYTICS") }}</p>
            </li>
            <li class="item fr">
              <div class="img-box">
                <img
                  src="~assets/main-page/home_ourfeatures_icon_08@3x.png"
                  alt=""
                />
              </div>
              <p class="text">{{ $t("language.mainFlexible") }}</p>
            </li>
          </ul>
        </div>
        <div class="classify-detail">
          <p>{{ $t("language.mainShowMore") }}</p>
          <div v-tap="{ methods: showFeaturesDetail }" class="expand-img">
            <img src="~assets/main-page/home_ourfeatures_btn_pop@3x.png" />
          </div>
        </div>
      </div>
      <!--feature展开部分-->
      <div class="feature-detail">
        <div class="top-contain">
          <h1>{{ $t("language.mainFeatures") }}</h1>
        </div>
        <div class="classify-contain">
          <div class="icon">
            <div v-tap="{ methods: hideFeaturesDetail }" class="icon-box">
              <img src="~assets/main-page/home_ourfeatures_btn_back@3x.png" />
            </div>
          </div>
          <ul class="classify-list">
            <li class="item">
              <h1>{{ $t("language.mainPERFORMANCE") }}</h1>
              <p>{{ $t("language.mainPERFORMANCEDetail") }}</p>
            </li>
            <li class="item">
              <h1>{{ $t("language.mainSECURITY") }}</h1>
              <p>{{ $t("language.mainRELIABILITYDetail") }}</p>
            </li>
            <li class="item">
              <h1>{{ $t("language.mainRELIABILITY") }}</h1>
              <p>{{ $t("language.mainSECURITYDetail") }}</p>
            </li>
            <li class="item">
              <h1>{{ $t("language.mainSMART") }}</h1>
              <p>{{ $t("language.mainSMARTDetail") }}</p>
            </li>
            <li class="item">
              <h1>{{ $t("language.mainEASY") }}</h1>
              <p>{{ $t("language.mainEASYDetail") }}</p>
            </li>
            <li class="item">
              <h1>{{ $t("language.mainREAL") }}</h1>
              <p>{{ $t("language.mainREALDetail") }}</p>
            </li>
            <li class="item">
              <h1>{{ $t("language.mainANALYTICS") }}</h1>
              <p>{{ $t("language.mainANALYTICSDetail") }}</p>
            </li>
            <li class="item">
              <h1>{{ $t("language.mainFlexible") }}</h1>
              <p>{{ $t("language.mainFlexibleDetail") }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--应用部分-->
    <div class="application-section">
      <div class="text-contain">
        <h1 class="title">{{ $t("language.mainGlobalImprove") }}</h1>
        <p class="text">{{ $t("language.mainGlobalSaas") }}</p>
        <div class="detail">
          <router-link :to="{ path: '/product/global' }" push>
            <span>{{ $t("language.mainClickShowMore") }}</span>
          </router-link>
        </div>
      </div>
      <div class="img-contain">
        <img src="~assets/main-page/home_img_01@3x.jpg" />
      </div>
      <div class="text-contain" v-if="language == 'en'">
        <h1 class="title">{{ $t("language.mainGlobalEnterprise") }}</h1>
        <p class="text">{{ $t("language.mainGlobalWith") }}</p>
        <div class="detail">
          <router-link :to="{ path: '/product/global' }" push>
            <span>{{ $t("language.mainClickShowMore") }}</span>
          </router-link>
        </div>
      </div>
      <div class="img-contain" v-if="language == 'en'">
        <img src="~assets/main-page/home_img_02@3x.jpg" />
      </div>
    </div>

    <!--地球-->
    <div class="world-section">
      <div class="title-contain">
        <div class="title">{{ $t("language.mainWorldwide") }}</div>
        <div class="title">{{ $t("language.mainSmart") }}</div>
      </div>

      <img class="world-img" src="~assets/main-page/home_img_03@3x.png" />
      <div class="world-text">
        <p>HQ/DC</p>
        <p>Branch Office</p>
      </div>
      <img class="icons" src="~assets/main-page/home_img_04@3x.png" />
    </div>
  </div>
</template>

<script>
import AppSwiper from "./independent/Swiper.vue";
export default {
  name: "MainPage",
  components: {
    AppSwiper,
  },
  props: ["language"],
  data() {
    return {
      scrollHeight: 0,
      minHeight: 0,
      maxHeight: 0,
    };
  },
  methods: {
    showTabDetail: function (event) {
      $(event.event.target).closest(".outer-item").toggleClass("show-detail");
    },
    showFeaturesDetail: function (event) {
      $(".feature-section").addClass("show-detail");
    },
    hideFeaturesDetail: function (event) {
      $(".feature-section").removeClass("show-detail");
    },
    scrollChange: function () {
      this.minHeight =
        $(".banner").outerHeight() +
        $(".tab-section").outerHeight() +
        $(".gradient").outerHeight() -
        $(".gradient .classify-detail").outerHeight();
      this.maxHeight =
        this.minHeight + $(".feature-section .feature-detail").outerHeight();
      this.scrollHeight = document.body.scrollTop || window.pageYOffset;
      if (
        this.minHeight < this.scrollHeight &&
        this.scrollHeight < this.maxHeight - 100
      ) {
        $(".feature-detail .classify-contain .icon-box").addClass(
          "for-position"
        );
      } else {
        $(".feature-detail .classify-contain .icon-box").removeClass(
          "for-position"
        );
      }
    },
    jumpRouter: function () {
      var top = $(".sdwan-page").height() - $(".section6").height();
      window.scroll(0, top);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollChange);
  },
  destroyed() {},
};
</script>

<style scoped lang="scss">
@function toRem($x) {
  @return $x / 37.5 * 1rem;
}
.banner {
  background: #f6f7f7;
}

/*4个下拉tab*/
.tab-section {
  padding: toRem(18) toRem(16);
  background: #f6f7f7;
}
.outer-item {
  background: #ffffff;
  margin-bottom: toRem(10);
}
/*tab头*/
.top-travel {
  padding: toRem(18) toRem(20);
  height: toRem(60);
}
.top-travel > * {
  height: 100%;
  line-height: 1;
}
.top-travel > * > * {
  display: inline-block;
  vertical-align: middle;
}
.top-travel .icon {
  width: toRem(90/3);
  height: toRem(90/3);
}
.top-travel .icon.icon2 {
  width: toRem(90/3);
  height: toRem(93/3);
}
.top-travel .text {
  padding-left: toRem(5);
  font-size: toRem(17);
  color: #333333;
}
.triangle-contain {
  line-height: toRem(30);
}
.triangle-contain .trangle {
  width: toRem(42/3);
  height: toRem(24/3);
}
/*tab详情*/
.tab-section li.show-detail .content {
  height: toRem(120);
}
.tab-section li.p4.show-detail .content {
  height: toRem(160);
}
.tab-section li.show-detail .trangle {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  transform: rotate(180deg);
}
.tab-section li .content {
  height: 0;
  overflow: hidden;
  border-top: toRem(1) solid #ebecec;
  -webkit-transition: height 0.2s linear;
  -moz-transition: height 0.2s linear;
  transition: height 0.2s linear;
}
.tab-section li .content p {
  padding-left: toRem(50);
  line-height: toRem(40);
  font-size: toRem(16);
  font-weight: 300;
  color: #666666;
}
.tab-section li .trangle {
  -webkit-transition: height 0.2s linear;
  -moz-transition: height 0.2s linear;
  transition: height 0.2s linear;
}

/*our features*/
.gradient {
  background: -webkit-linear-gradient(
    181deg,
    #2cd8d5 0%,
    #44bbd5 21%,
    #44bbd5 22%,
    #6b8dd6 48%,
    #844fd7 80%,
    #8e37d7 100%
  );
  background: -moz-linear-gradient(
    181deg,
    #2cd8d5 0%,
    #44bbd5 21%,
    #44bbd5 22%,
    #6b8dd6 48%,
    #844fd7 80%,
    #8e37d7 100%
  );
  background: linear-gradient(
    181deg,
    #2cd8d5 0%,
    #44bbd5 21%,
    #44bbd5 22%,
    #6b8dd6 48%,
    #844fd7 80%,
    #8e37d7 100%
  );
  color: #fff;
  padding: 0 toRem(38);
  padding-bottom: toRem(10);
}
/*our features 文字*/
.feature-section .top-text-contain {
  padding-top: toRem(40);
  padding-bottom: toRem(30);
  width: toRem(304);
  margin: 0 auto;
}
.feature-section .top-text-contain .top-title {
  font-size: toRem(22);
  padding-bottom: toRem(14);
}
.feature-section .top-text-contain .middle-title {
  font-size: toRem(13);
  padding-bottom: toRem(8);
}
.feature-section .top-text-contain .bottom-text {
  font-size: toRem(13);
}

/*our features item*/
.feature-classify {
  width: toRem(304);
  margin: 0 auto;
}
.all-item {
  padding-bottom: toRem(4);
}
.feature-classify .item {
  width: toRem(150);
  height: toRem(100);
  background: rgba(0, 0, 0, 0.2);
  border: toRem(1) solid #ffffff;
  text-align: center;
}
.feature-classify .img-box {
  padding-top: toRem(17);
  height: toRem(70);
}
.feature-classify .img-box img {
  display: inline-block;
  width: toRem(100/3);
  height: toRem(100/3);
}
.feature-classify .img-box img.img2 {
  width: toRem(84/3);
}
.feature-classify .img-box img.img4 {
  width: toRem(72/3);
  height: toRem(102/3);
}
.feature-classify .img-box img.img5 {
  width: toRem(87/3);
  height: toRem(100/3);
}
.feature-classify .item p {
  font-size: toRem(12);
}

/*展开*/
.classify-detail {
  height: toRem(100);
  padding-top: toRem(20);
  text-align: center;

  font-size: toRem(12);
  letter-spacing: toRem(1.23);
  -webkit-transition: all 0.5s linear;
  -moz-transition: all 0.5s linear;
  transition: all 0.5s linear;
  opacity: 1;
}
.classify-detail .expand-img {
  padding-bottom: toRem(32);
}
.classify-detail img {
  margin-top: toRem(10);
  display: inline-block;
  width: toRem(66/3);
  height: toRem(66/3);
}
/*feature详情*/
.feature-detail {
  position: relative;
  background: #e6e6fe;
  /*height: toRem(1166);*/
  height: 0;
  opacity: 0;
  overflow: hidden;
  -webkit-transition: all 0.5s linear;
  -moz-transition: all 0.5s linear;
  transition: all 0.5s linear;
}
.feature-detail .top-contain {
  height: toRem(160);
  background: #a2a2e9;
}
.feature-detail .top-contain h1 {
  font-size: toRem(22);
  color: #ffffff;
  padding-top: toRem(36);
  text-align: center;
}
.feature-detail .classify-contain {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 toRem(14);
}
.feature-detail .classify-contain .icon {
  height: toRem(94);
  padding-top: toRem(60);
  text-align: center;
}
.feature-detail .classify-contain .icon-box {
  display: inline-block;
  height: toRem(40);
  padding-top: toRem(10);
  width: toRem(100);
}
.feature-detail .classify-contain .icon-box.for-position {
  // position: fixed;
  top: toRem(100);
  left: 36%;
}
.feature-detail .classify-contain .icon img {
  display: inline-block;
  width: toRem(66/3);
  height: toRem(66/3);
}
.classify-list .item {
  text-align: left;
  height: toRem(120);
  background: #ffffff;
  margin-top: toRem(10);
  padding: toRem(24) toRem(24) 0 toRem(24);
}
.classify-list .item h1 {
  font-size: toRem(16);
  color: #4e4dda;
  padding-bottom: toRem(6);
  font-weight: 400;
}
.classify-list .item p {
  font-size: toRem(14);
  color: #999999;
  line-height: toRem(16);
}

.feature-section.show-detail .classify-detail {
  height: 0;
  padding: 0;
  opacity: 0;
}
.feature-section.show-detail .feature-detail {
  height: toRem(1166);
  opacity: 1;
}

/*应用区域*/
.application-section .text-contain {
  padding: toRem(48) toRem(36) toRem(20) toRem(36);
}
.application-section .text-contain .title {
  font-weight: 500;
  font-size: toRem(18);
  color: #4e4dda;
  line-height: toRem(27);
  padding-bottom: toRem(14);
}
.application-section .text-contain .text {
  opacity: 0.7;

  font-size: toRem(13);
  color: #666666;
  line-height: toRem(18);
}
.application-section .text-contain .detail a {
  display: inline-block;
}
.application-section .text-contain .detail span {
  display: inline-block;
  font-size: toRem(16);
  color: #4e4dda;
  padding: toRem(14) 0;
}

.application-section .img-contain {
  width: 100%;
  height: toRem(237);
}
.application-section .img-contain img {
  width: 100%;
  height: 100%;
}

/*地球区域*/
.world-section {
  background: #1f1f3f;
  text-align: center;
  padding-top: toRem(90);
  padding-bottom: toRem(83);
}
.world-section .title-contain {
  padding-bottom: toRem(57);
  font-size: toRem(16);
  color: #ffffff;
  line-height: toRem(26);
}
.world-section .world-img {
  width: toRem(768/3);
  height: toRem(723/3);
  display: inline-block;
  /*margin:0 auto;*/
}
.world-section .world-text {
  padding-top: toRem(56);

  font-size: toRem(14);
  color: #01ffff;
}
.world-section .world-text p:nth-of-type(2) {
  padding-top: toRem(10);
}
.world-section .icons {
  width: toRem(723/3);
  height: toRem(63/3);
  margin-top: toRem(16);
}
</style>



// WEBPACK FOOTER //
// MainPage.vue?10289866